import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const GET_POLICY_VIEW_FINANCING_MODEL = "GET_POLICY_VIEW_FINANCING_MODEL";

export interface PolicyViewHeader {
  label: string;
  tableName: string;
}

export interface PolicyViewRow {
  id: string;
  insuredAge: number;
  policyYear: number;
  year: number;
  clientPremium: number;
  lenderPremium: number;
  totalPolicyPremium: number;
  estimatedLoanPayoffOrIncome: number;
  illustratedPolicyAccumulatedValue: number;
  illustratedPolicySurrenderValue: number;
  illustratedPolicyDB: number;
  illustratedTotalIncomeToCurYear: number;
  totalIncomeReceivedPlusCurDB: number;
}

export interface PolicyViewResponse {
  data: {
    headers: PolicyViewHeader[];
    rows: PolicyViewRow[];
  } | null;
  status: string;
}

interface CommonState<T> {
  loading: boolean;
  data: T | null;
  error: any | null;
}

interface InitialState {
  policyView: CommonState<PolicyViewResponse>;
}

const initialState: InitialState = {
  policyView: { loading: false, data: null, error: null },
};

export const policyViewFinancingModelSlice = createSlice({
  name: "policyViewFinancingModel",
  initialState,
  reducers: {
    policyViewFetchStart: (state) => {
      state.policyView = { loading: true, data: null, error: null };
    },
    policyViewFetchSuccess: (state, action: PayloadAction<PolicyViewResponse>) => {
      state.policyView = { loading: false, data: action.payload, error: null };
    },
    policyViewFetchError: (state, action: PayloadAction<any>) => {
      state.policyView = { loading: false, data: null, error: action.payload };
    },
    resetPolicyView: (state) => {
      state.policyView = { loading: false, data: null, error: null };
    },
  },
});

export const {
  policyViewFetchStart,
  policyViewFetchSuccess,
  policyViewFetchError,
  resetPolicyView,
} = policyViewFinancingModelSlice.actions;

export const getPolicyViewFinancingModel = (state: RootState) =>
  state.policyViewFinancingModelReducer;

export default policyViewFinancingModelSlice.reducer;
